/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFuelReimburseLookup.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/fuel-reimburse-lookup";

export class AutogenModelFuelReimburseLookup<RowType extends ModelRow> extends Endpoint<RowType, RowFuelReimburseLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFuelReimburseLookup extends ModelRow<RowFuelReimburseLookupFields> {
	constructor(values?: Partial<RowFuelReimburseLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFuelReimburseLookupFields {
	company_id: string;
	deduct_code: string;
	id: string;
	is_active: string;
}

